module.exports = __webpack_public_path__ + "img/icon3.a0053bd4.png";